export function slug(text) {
  return (text || "")
    .replace(/[\u2019']/g, "'")
    .replace(/'S\b/gi, "")
    .replace(/'/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function suggestPrefix(productName) {
  const parts = slug(productName).split("-").filter(Boolean);
  return parts.slice(0, 2).join("-") || "PROD";
}

export function getOrderedOptionValues(optionValues, optionOrder = []) {
  const ov = optionValues || {};

  if (!Array.isArray(optionOrder) || optionOrder.length === 0) {
    return Object.values(ov);
  }

  const used = new Set();
  const ordered = [];

  // First, take values in the explicit option order.
  optionOrder.forEach((name) => {
    if (Object.prototype.hasOwnProperty.call(ov, name)) {
      ordered.push(ov[name]);
      used.add(name);
    }
  });

  // Then append any extra keys not present in optionOrder to avoid data loss.
  Object.entries(ov).forEach(([key, value]) => {
    if (!used.has(key)) ordered.push(value);
  });

  return ordered;
}

export function buildSku(prefix, optionValues, optionOrder = []) {
  const vals = getOrderedOptionValues(optionValues, optionOrder).map((v) => slug(v));
  return [slug(prefix), ...vals].filter(Boolean).join("-");
}
